function handleLists(document) {
	const lists = document.querySelectorAll('.result-word ol');
	if (lists && lists.length > 0) {
		lists.forEach((listParent) => {
			const liItems = listParent.querySelectorAll('li');
			if (liItems && liItems.length > 0) {
				liItems.forEach((item, i) => {
					// We use jQuery, because document, is not necessarily the actual document, so it throws error using document.createElement.
					jQuery(item).prepend(jQuery('<span/>').text(`${i + 1}. `));
				});
			}
		});
	}
}

const fixEncoding = (text) => {
	let output = '';
	for (let i = 0; i < text.length; i++) {
		// Here we strip weird characters from the PDF, and adds a space for the char after (R)
		if (text.charCodeAt(i) <= 246) {
			output += text.charAt(i);
		}
		if (text.charCodeAt(i) === 8201) {
			output += ' ';
		}
	}
	return output;
};

const opt = {
	pagebreak: {
		mode: ['avoid-all'],
		after: ['.result-hiiva'],
	},
	margin: [20, 12, 12, 12],
	filename: 'gutindex.pdf',
	html2canvas: {
		scale: 2,
		letterRendering: true,
		windowWidth: 1920,
		onclone: (document) => handleLists(document),
	},
	jsPDF: { unit: 'mm', format: 'a3', orientation: 'p' },
};

function generatePDF(response, loadingEl) {
	const htmlString = response.data;
	const parser = new DOMParser();
	const htmlDoc = parser.parseFromString(htmlString, 'text/html');
	const element = htmlDoc.querySelector('.gutindex');
	const data = htmlDoc.querySelector('.pdf-extra-data');
	htmlDoc.querySelectorAll('iframe').forEach((el) => el.remove());
	htmlDoc.querySelectorAll('.fskey-tooltip').forEach((el) => el.remove());
	if (!data) return;
	document.body.appendChild(element);
	const logo = new Image();
	logo.src = data.getAttribute('data-logo');
	logo.onload = function () {
		html2pdf()
			.from(element)
			.set(opt)
			.toPdf()
			.get('pdf')
			.then((pdf) => {
				const totalPages = pdf.internal.getNumberOfPages();
				console.log('getHeight:' + pdf.internal.pageSize.getHeight());
				console.log('getWidth:' + pdf.internal.pageSize.getWidth());
				for (let i = 1; i <= totalPages; i++) {
					pdf.setPage(i);
					pdf.setFontSize(10);
					pdf.setTextColor(58, 60, 61);
					//pdf.setTextColor(0, 133, 202);

					const nameWidth = pdf.getTextWidth(data.getAttribute('data-user'));

					const title = fixEncoding(data.getAttribute('data-title'));
					const user = fixEncoding(data.getAttribute('data-user'));

					pdf.addImage(logo, 'PNG', 12, 10, 32.5, 4.65);
					pdf.text(title, 50, 14);
					pdf.text(user, 285 - nameWidth, 14);
					pdf.setDrawColor(209, 211, 208);
					pdf.setLineWidth(0.4);
					pdf.line(12, 20, 285, 20);
				}
			})
			.save()
			.then(() => {
				if (loadingEl) loadingEl.classList.add('d-none');
				document.body.removeChild(element);
				enableScroll();
			})
			.catch((err) => {
				console.error(err);
				if (loadingEl) loadingEl.classList.add('d-none');
				enableScroll();
			});
	};
}

window.addEventListener('DOMContentLoaded', function () {
	const generateButton = document.querySelector('.generate-pdf');
	if (generateButton)
		generateButton.addEventListener('click', function (evt) {
			const polylang_lang = restAPI.polylang_lang ?? 'fi';
			const lang = restAPI.lang ?? 'fi';
			const el = evt.target;
			const slug = el.getAttribute('data-slug');
			const loadingEl = document.querySelector('#loading-modal');
			if (loadingEl) loadingEl.classList.remove('d-none');
			disableScroll();
			fetch(
				`${restAPI.root}gutguide/v1/generate_pdf?slug=${slug}&polylang_lang=${polylang_lang}&lang=${lang}`,
				{
					headers: { 'X-WP-Nonce': restAPI.nonce },
				}
			)
				.then((r) => r.json())
				.then((r) => JSON.parse(r))
				.then((r) => generatePDF(r, loadingEl))
				.catch((err) => {
					console.error(err);
					if (loadingEl) loadingEl.classList.add('d-none');
					enableScroll();
				});
		});
	const pdfData = document.querySelector('.data-pdf');
	if (pdfData) handleLists(pdfData);
});
